export interface ITitleClient {
  setTitle(title: string): void;
}

export class BrowserTitleClient implements ITitleClient {
  setTitle(title: string): void {
    document.title = title;
  }
}